module.exports = __webpack_public_path__ + "static/media/2025_ksms.ee48fcc7.png";